var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLike2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27 26",
    "aria-labelledby": "likeIcon likeDesc"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.675 22.784H3.432a2.162 2.162 0 01-2.162-2.162v-7.568a2.162 2.162 0 012.162-2.162h3.243m7.568-2.162V4.405A3.243 3.243 0 0011 1.162l-4.325 9.73v11.892H18.87a2.162 2.162 0 002.162-1.838l1.492-9.73a2.163 2.163 0 00-2.162-2.486h-6.119z"
  })));
}

export default SvgLike2;